module.exports = __webpack_public_path__ + "img/outline-carret-green.d32a01e5.svg";